export default "__VITE_ASSET__b8594463__"